import './addtocalendar.less'

import load from 'load-script'
import React, {useEffect, useState} from 'react'
import {style} from 'util/style'
import {Theme} from 'views/theme'

const styles = style('addtocalendar')

export type AddtocalendarType = {
	code: string
}

const isLoaded = false

export const Addtocalendar: React.FC<AddtocalendarType> = ({code}) => {
	if (!code) return null
	const [visible, setVisible] = useState(isLoaded)
	const acceptedCookies = localStorage.getItem('acceptedCookies')

	useEffect(() => {
		if (acceptedCookies && !isLoaded) {
			load('https://addevent.com/libs/atc/1.6.1/atc.min.js', err => {
				if (!err) setVisible(true)
			})
		}
	}, [acceptedCookies])

	return (
		<div className={styles().is({visible})}>
			<Theme.Container>
				<div
					className={styles('content').is({visible})}
					dangerouslySetInnerHTML={{
						__html: code
					}}
				/>
			</Theme.Container>
		</div>
	)
}
